import { defineMessages } from 'react-intl';

export default defineMessages({
    amBestImgAltText: {
        id: 'gw-capability-quoteandbind-common-react.components.WMICCustomerFooter.amBestImgAltText',
        defaultMessage: 'AM Best Financial Strength Rating: A+ Superior'
    },
});
